<template>
  <v-dialog v-model="model" max-width="1280">
    <v-card class="dialog-container">
      <v-card-title class="px-8 py-4 document-title">
        {{ title }}
      </v-card-title>
      <v-card-text class="pa-8">
        <iframe v-if="pdfUrl" :src="pdfUrl" class="pdf-container" />
        <v-skeleton-loader
          v-else
          type="article"
          :types="skeleton"
          class="pdf-container mb-2"
        />
      </v-card-text>
      <v-card-actions class="pl-7 pr-7 pb-7 pt-0">
        <v-spacer />
        <v-btn class="px-4" color="primary" depressed @click="downloadFile">
          Stáhnout
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import http from "@/http";
import downloadFile from "@/utils/downloadFile";
import downloadLocalFile from "@/utils/downloadLocalFile";

export default {
  name: "DocumentPreviewDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    fileUuid: {
      type: String,
      default: undefined,
    },
    fileType: {
      type: String,
      default: "upload",
    },
    fileName: {
      type: String,
      default: undefined,
    },
  },
  emits: ["input"],
  data() {
    return {
      model: true,
      pdfUrl: undefined,
      skeleton: {
        article:
          "heading, paragraph, divider, paragraph, card, paragraph, table, paragraph@2",
      },
    };
  },
  watch: {
    value: {
      async handler(value) {
        this.model = value;
        if (value) {
          this.pdfUrl = undefined;
          await this.loadFile();
        }
      },
      immediate: true,
    },
    model: {
      handler(value) {
        this.$emit("input", value);
      },
      immediate: true,
    },
  },
  methods: {
    async loadFile() {
      if (this.fileName) {
        this.pdfUrl = this.fileName;
      } else {
        const decodedUrl = decodeURIComponent(
          `/${this.fileType}/${this.fileUuid}`
        );
        const response = await http.get(decodedUrl, { responseType: "blob" });
        this.pdfUrl = window.URL.createObjectURL(response.data);
      }
    },
    async downloadFile() {
      if (this.fileName) {
        await downloadLocalFile(this.fileName);
      } else {
        await downloadFile(this.fileType, this.fileUuid);
      }
    },
  },
};
</script>

<style scoped>
.v-card__title {
  background-color: #fff100 !important;
}

.pdf-container {
  width: 100%;
  height: calc(100vh - 320px);
}

.dialog-container {
  height: calc(100vh - 100px);
}

@media (max-width: 600px) {
  .document-title {
    font-size: 16px !important;
  }
}
</style>
